// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "" + chunkId + "-" + {"228":"0e2cab60","707":"381f8b96","729":"07963657"}[chunkId] + ".js";
};